/* VIDA - Pagina de carrito: cambia cantidades y quita productos SIN recargar la pagina.
   Usa /cart/change.js y vuelve a pedir solo esta seccion (Section Rendering API). Sin JavaScript, el formulario sigue funcionando de forma normal. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart-root]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var timer, busy = false, pending = null;

  function status(msg) { var s = root.querySelector('[data-cart-status]'); if (s) s.textContent = msg || ''; }

  function refreshIcon() {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    fetch(window.routes.cart_url + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var src = d.querySelector('.shopify-section') || d.body;
        icon.innerHTML = src.innerHTML;
      }).catch(function () { /* el contador se actualiza en la siguiente carga */ });
  }

  function render(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var next = d.querySelector('[data-cart-root]');
    if (!next) { window.location.reload(); return; }
    root.innerHTML = next.innerHTML;
    bind();
  }

  function change(line, quantity) {
    root.classList.add('is-updating'); busy = true;
    return fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { status(res.json && (res.json.description || res.json.message) || ''); }
        return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId));
      })
      .then(function (r) { return r.text(); })
      .then(function (html) { render(html); refreshIcon(); status(window.vidaT && window.vidaT('cart.page_updated') || ''); })
      .catch(function () { window.location.reload(); })
      .finally(function () { busy = false; root.classList.remove('is-updating'); if (pending) { var p = pending; pending = null; change(p.line, p.quantity); } });
  }

  function queue(line, quantity) {
    clearTimeout(timer);
    timer = setTimeout(function () { if (busy) pending = { line: line, quantity: quantity }; else change(line, quantity); }, 350);
  }

  function bind() {
    root.querySelectorAll('.v-citem').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var q = row.querySelector('[data-qty]'); if (!q) return;
      var input = q.querySelector('[data-line-qty]');
      q.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 1) - 1); queue(line, +input.value); });
      q.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = Math.min(99, (parseInt(input.value, 10) || 0) + 1); queue(line, +input.value); });
      input.addEventListener('change', function () { var v = parseInt(input.value, 10); input.value = isNaN(v) || v < 0 ? 1 : Math.min(99, v); queue(line, +input.value); });
      var rm = row.querySelector('.v-citem__remove');
      if (rm) rm.addEventListener('click', function (e) { e.preventDefault(); queue(line, 0); });
    });
  }
  bind();
})();
